import useTheme from 'chat-ui/src/hooks/useTheme';
import PasswordEditForm from '@/components/forms/PasswordEditForm';
import ProfileEditForm from '@/components/forms/ProfileEditForm';
import TwoFactorAuthForm from '@/components/forms/TwoFactorAuthForm';
import NotificationPreferencesForm from '@/components/forms/NotificationPreferencesForm';
import DeleteAccountForm from '@/components/forms/DeleteAccountForm';

function MyProfile() {
  const { currentTheme } = useTheme();

  return (
    <div style={{ color: currentTheme?.['primary-text'] }} className="max-w-3xl mx-3 min450:mx-0">
      <ProfileEditForm />
      <PasswordEditForm />
      <TwoFactorAuthForm />
      <NotificationPreferencesForm />
      <DeleteAccountForm />
    </div>
  );
}

export default MyProfile;
